import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const DeleteTeamContext = createContext(null);

type Props = {
  children: ReactElement;
};

const DeleteTeamProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload: any) => {
      const data = await Api.delete(`settings/tm/case-management/groups`, {
        data: payload,
      });
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      isPending,
      error,
    }),
    [mutateAsync, data, isPending, error],
  );
  return (
    <DeleteTeamContext.Provider value={contextValue}>
      {children}
    </DeleteTeamContext.Provider>
  );
};

export default DeleteTeamProvider;
